
import AccentWallBefore from '../Resources/Projects/Accent Wall/Accent Wall Before.jpg';
import AccentWallAfter from '../Resources/Projects/Accent Wall/Accent Wall After.jpg';
import DrywallCornerBefore from '../Resources/Projects/Drywall Corner/Drywall Corner Before.jpg';
import DrywallCornerAfter from '../Resources/Projects/Drywall Corner/Drywall Corner After.jpg';
import BulkheadBefore from '../Resources/Projects/Drywall Corner/Bulkhead Before.jpg';
import BulkheadAfter from '../Resources/Projects/Drywall Corner/Bulkhead After.jpg';
import ElectricFireplaceBefore from '../Resources/Projects/Electric Fireplace/Electric Fireplace Before.jpg';
import ElectricFireplaceAfter from '../Resources/Projects/Electric Fireplace/Electric Fireplace After.jpg';
import ExteriorPaintingBefore from '../Resources/Projects/Exterior Painting/Exterior Painting Before.jpg';
import ExteriorPaintingAfter from '../Resources/Projects/Exterior Painting/Exterior Painting After.jpg';
import FoodTruckBefore from '../Resources/Projects/Food Truck/Food Truck Before.jpg';
import FoodTruckAfter from '../Resources/Projects/Food Truck/Food Truck After.jpg';
import FoodTruckBefore2 from '../Resources/Projects/Food Truck/Food Truck Before 2.jpg';
import FoodTruckAfter2 from '../Resources/Projects/Food Truck/Food Truck After 2.jpg';
import InteriorPaintingBefore from '../Resources/Projects/Interior Painting/Interior Painting Before.jpg';
import InteriorPaintingAfter from '../Resources/Projects/Interior Painting/Interior Painting After.jpg';
import KitchenBacksplashBefore from '../Resources/Projects/Kitchen Backsplash/Kitchen Backsplash Before.jpg';
import KitchenBacksplashAfter from '../Resources/Projects/Kitchen Backsplash/Kitchen Backsplash After.jpg';
import MetalStairsBefore from '../Resources/Projects/Metal Stairs/Metal Stairs Before.jpg';
import MetalStairsAfter from '../Resources/Projects/Metal Stairs/Metal Stairs After.jpg';
import OfficeBefore from '../Resources/Projects/Office Paint/Office Before.jpg';
import OfficeAfter from '../Resources/Projects/Office Paint/Office After.jpg';
import OfficeBefore2 from '../Resources/Projects/Office Paint/Office Before 2.jpg';
import OfficeAfter2 from '../Resources/Projects/Office Paint/Office After 2.jpg';
import StoreDisplayBefore from '../Resources/Projects/Store Display/Store Display Before.jpg';
import StoreDisplayAfter from '../Resources/Projects/Store Display/Store Display After.jpg';
import FlooringBefore from '../Resources/Projects/Flooring/FlooringBefore.jpg';
import FlooringAfter from '../Resources/Projects/Flooring/FlooringAfter.jpg';

const ProjectList = [
    {
        name: 'Food Truck',
        images: [
            FoodTruckBefore, FoodTruckAfter
        ],
        desc: 'A camper we gutted and repurposed into a working up to code food trailer for company use.'
    },
    {
        name: 'Food Truck 2',
        images: [
            FoodTruckBefore2, FoodTruckAfter2
        ],
        desc: 'A camper we gutted and repurposed into a working up to code food trailer for company use. View 2.'
    },
    {
        name: 'Flooring',
        images: [
            FlooringBefore, FlooringAfter
        ],
        desc: 'Condo engineered hardwood was removed due to water damage and replaced with vinyl.'
    },
    {
        name: 'Exterior Painting',
        images: [
            ExteriorPaintingBefore,ExteriorPaintingAfter
        ],
        desc: 'Exterior painting of a faded house.'
    },
    {
        name: 'Electric Fireplace',
        images: [
            ElectricFireplaceBefore, ElectricFireplaceAfter
        ],
        desc: 'Electric Fireplace for a condo partyroom.'
    },
    {
        name: 'Accent Wall',
        images: [
            AccentWallBefore, AccentWallAfter
        ],
        desc: 'Airbnb master bedroom accent wall added'
    },
    {
        name: 'Interior Painting',
        images: [
            InteriorPaintingBefore, InteriorPaintingAfter
        ],
        desc: 'Living room repainted before listing (ceilings, walls, trim).'
    },
    {
        name: 'Kitchen Backsplash',
        images: [
            KitchenBacksplashBefore, KitchenBacksplashAfter
        ],
        desc: 'Added Backsplash to kitchen'
    },
    {
        name: 'Metal Stairs',
        images: [
            MetalStairsBefore, MetalStairsAfter
        ],
        desc: 'Metal stairs refresh and paint.'
    },
    {
        name: 'Office',
        images: [
            OfficeBefore, OfficeAfter
        ],
        desc: 'Boardroom Office Drywall Repair and Paint.'
    },
    {
        name: 'Office 2',
        images: [
            OfficeBefore2, OfficeAfter2
        ],
        desc: 'Boardroom Office Drywall Repair and Paint. View 2.'
    },
    {
        name: 'Store Display',
        images: [
            StoreDisplayBefore, StoreDisplayAfter
        ],
        desc: 'Custom display for a flooring store'
    },
    {
        name: 'Drywall Coner',
        images: [
            DrywallCornerBefore, DrywallCornerAfter
        ],
        desc: 'Wall removed and new drywall corner finished'
    },
    {
        name: 'Bulkhead',
        images: [
            BulkheadBefore, BulkheadAfter
        ],
        desc: 'Bulkhead installed and drop ceiling extended'
    },


]

export default ProjectList